import { mapState, mapActions } from 'vuex'
import { create } from 'vue-modal-dialogs'
import ConfirmArchiveEntityDialog from '../components/ConfirmArchiveEntityDialog'
import ConfirmDeleteEntityDialog from '../components/ConfirmDeleteEntityDialog'
import entityPerimeter from '../perimeters'
import { NAMESPACE as REALTIME_NAMESPACE } from '@argon/realtime/store'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE } from '../store'

const confirmDeleteAction = create(ConfirmDeleteEntityDialog)
const confirmArchiveAction = create(ConfirmArchiveEntityDialog)

export default {
  perimeters: [entityPerimeter],
  name: 'CardMixin',
  props: {
    orgRef: String,
    entityId: { type: [String, Number], required: true },
    boardRef: { type: String, required: true }
  },
  data: () => ({
    propertiesLink: 'entityProperties',
    usersLink: 'entityUsers',
    nestedEntity: false,
    include: 'users'
  }),
  computed: {
    ...mapState(BOARD_NAMESPACE, ['board']),
    ...mapState(NAMESPACE, ['boardItem', 'displayType']),
    hasBoardItem() {
      return !!this.boardItem
    },
    hasTransitionWarning() {
      return this.boardItem.report.transition
        ? this.boardItem.report.transitions.some((item) => item.status !== 'DONE')
        : false
    },
    readOnly() {
      return (
        this.boardItem &&
        this.$entity.isAllowed('read', this.boardItem.entity) &&
        !this.$entity.isAllowed('update', this.boardItem.entity)
      )
    },
    proxyURL() {
      return `/boards/${this.boardRef}/items/${this.entityId}`
    },
    realtimeKey() {
      return this.boardItem && this.board
        ? this.$store.getters[`${REALTIME_NAMESPACE}/realtimeKey`]({
            category: `${this.board.entity_type}Items`,
            identifier: this.boardItem.entity.refid
          })
        : null
    }
  },
  methods: {
    ...mapActions(REALTIME_NAMESPACE, ['addListener', 'removeListenerCategory']),
    ...mapActions(BOARD_NAMESPACE, ['getBoard']),
    ...mapActions(NAMESPACE, ['getBoardItem', 'archiveEntities', 'listPrincipals', 'deleteEntity', 'clearEntity']),
    computeRoute(link) {
      return {
        name: this.nestedEntity && this.displayType ? `${this.displayType}${link}` : link,
        params: {
          ...this.$router.params
        }
      }
    },
    showProperties() {
      let route = this.computeRoute(this.propertiesLink)
      this.$router.push(route)
    },
    showUsers() {
      let route = this.computeRoute(this.usersLink)
      this.$router.push(route)
    },
    archive() {
      return confirmArchiveAction().then((res) => {
        if (res) {
          this.archiveEntities([this.boardItem.entity.uris.self]).then(() => {
            this.dismiss()
          })
        }
      })
    },
    destroy() {
      return confirmDeleteAction().then((res) => {
        if (res) {
          this.deleteEntity(this.boardItem.entity.uris.self).then(() => {
            this.dismiss()
          })
        }
      })
    },
    fetchData() {
      return this.getBoard(this.boardRef)
        .then(() => {
          return this.getBoardItem({ url: this.proxyURL, include: this.include })
        })
        .then((item) => {
          return this.listPrincipals(item.entity.uris.self)
        })
        .catch(() => {
          this.dismiss()
        })
    }
  },
  watch: {
    realtimeKey: function (v, oldV) {
      if (oldV) {
        this.fetchData()
      }
    }
  },
  created() {
    this.fetchData().then(() => {
      if (this.boardItem && this.board) {
        this.addListener({ category: `${this.board.entity_type}Items`, identifier: this.boardItem.entity.refid })
      }
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchData()
    next()
  },
  destroyed() {
    if (this.board) {
      this.removeListenerCategory(`${this.board.entity_type}Items`)
    }
    this.clearEntity()
  }
}
